export class PersonalInfo {
    civility: string | undefined;

    lastName: string = '';

    firstName: string = '';

    birthDate: Date | undefined;

    address: string | undefined;

    complement: string | undefined;

    zipCode: string | undefined;

    city: string | undefined;

    country: string | undefined;

    email: string | undefined;

    phoneNumber: string | undefined;

    newsletter: boolean = false;

    openWeddingList: boolean = false;

    contactIfSlotAvailable: boolean = false;
}

export interface PersonalInfoFormOwnProps {
    model: PersonalInfo;
    onSuccess: (model: PersonalInfo) => void;
    onCancel: () => void;
}

export type PersonalInfoFormProps = PersonalInfoFormOwnProps;
